module.exports = __webpack_public_path__ + "static/img/handle_board.6e0420c3.png";